import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { OrganizationPreferenceResponse } from '../../interface/organizationPreference.interface';
import { organizationPreferenceActions } from '../action/organizationPreference.action';

interface OrganizationPreferenceState {
  preferences: OrganizationPreferenceResponse['data']['preferences'];
  isLoading: boolean;
  error: string | null;
}

const initialState: OrganizationPreferenceState = {
  preferences: [],
  isLoading: false,
  error: null,
};

const organizationPreferenceSlice = createSlice({
  name: 'organizationPreferences',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(organizationPreferenceActions.fetchOrganizationPreferences.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.preferences = [];
      })
      .addCase(
        organizationPreferenceActions.fetchOrganizationPreferences.fulfilled,
        (state, action: PayloadAction<OrganizationPreferenceResponse>) => {
          state.isLoading = false;
          state.preferences = action.payload.data.preferences;
        },
      )
      .addCase(
        organizationPreferenceActions.fetchOrganizationPreferences.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error =
            action.payload?.message ||
            i18n.t('toast.failed_to_fetch_preferences', 'Failed to fetch preferences.');
          state.preferences = [];
        },
      )
      .addCase(organizationPreferenceActions.putOrganizationPreferences.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        organizationPreferenceActions.putOrganizationPreferences.fulfilled,
        (state, action: PayloadAction<OrganizationPreferenceResponse>) => {
          state.isLoading = false;
          state.preferences = action.payload.data.preferences;
        },
      )
      .addCase(
        organizationPreferenceActions.putOrganizationPreferences.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error =
            action.payload?.message ||
            i18n.t('toast.failed_to_update_preferences', 'Failed to update preferences.');
        },
      );
  },
});

export default organizationPreferenceSlice.reducer;
